
<script>
    import { onMount } from "svelte";
    import { writable } from "svelte/store";

    const token = "4zyE51eWthh21ZNBB5rymdV3Pgen2DXH7HiLdfi2AKtX";
    let currentPrice = writable({ price: "Loading..." });
    let initialLoad = writable(true);
    let loading = writable(true);
    let error = writable(null);
    let lastUpdated = "";

    const fetchPrice = async () => {
        try {
            loading.set(true);
            error.set(null);
            const price_url = `https://api.jup.ag/price/v2?ids=${token}&showExtraInfo=true`;
            const response = await fetch(price_url);
            const data = await response.json();
            const price = data.data[token].extraInfo.quotedPrice.buyPrice;
            currentPrice.set({price: price});
            lastUpdated = new Date().toLocaleTimeString();
            loading.set(false);
            initialLoad.set(false);  // Stop showing loading on subsequent fetches
        } catch (e) {
            error.set("Failed to fetch price");
            loading.set(false);
        }
    };

    onMount(
        fetchPrice,
        setInterval(fetchPrice, 10000)
    )
</script>
{#if $error}
    <div class="error"></div>
{:else}
    <div class="price-container">
        <span class="price">Price: ${$currentPrice.price}</span>
        <div class="meta-info">
            <span id="last-updated">Last updated: {lastUpdated}</span>
            <span id="powered-by-jup"><img id="powered-by-jup-image" src="https://jup.ag/svg/jupiter-logo.svg" />Powered by JUP API</span>
        </div>
    </div>
{/if}

<style>

    #powered-by-jup-image {
        max-height: 15px;
        margin-right: 5px;
    }

    #powered-by-jup {
        display: flex;
        align-items: center;
    }

    #last-updated {
        display: flex;
        align-items: center;
    }

    .loading-spinner {
        font-size: 1.5em;
        color: #666;
        text-align: center;
        margin: 20px 0;
    }

    .price-container {
        margin-top: 25px;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 15px;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    }

    .price {
        font-size: 1.5em;
        color: #333;
    }

    .meta-info {
        display: flex;
        justify-content: space-between;
        width: 100%;
        font-size: 0.9em;
        color: #888;
    }

    .meta-info span {
        margin: 0 5px;
    }
</style>
